import React from 'react'
import { Notification as BaseNotification } from 'react-admin'

const Notification = (props) => (
  <BaseNotification {...props} autoHideDuration={10000} />
)

export default Notification
